
import { Navbar } from '@/components/Navbar';
import { NewsFeed } from '@/components/NewsFeed';
import { Footer } from '@/components/Footer';
import { Helmet } from 'react-helmet';
import { useLanguage } from '@/hooks/useLanguage';

const Index = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>{t('news.pageTitle')} | Cybermonit</title>
      </Helmet>
      <Navbar />
      <main className="flex-grow">
        <NewsFeed />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
